module.exports = __webpack_public_path__ + "assets/img/wlhy-en.377441b5.jpg";